import { createSelector } from "reselect";
import { isEmpty } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const privacy = state.profile.privacy;

  if (isEmpty(privacy)) {
    return false;
  }

  return privacy.images;
};
//VERIFY IF THE JWT IS SET
const showMemberGallery = createSelector(getData, show => show);
export default showMemberGallery;



// WEBPACK FOOTER //
// ./src/_selectors/profileSelectors/showMemberGallery.js